import type { ButtonHTMLAttributes } from 'react'
import { cn } from '~/utils/cn'

const Button = ({
	className,
	loading = false,
	children,
	...restProps
}: {
	loading?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
	const classList = cn(
		'relative bg-zephyr-blue hover:bg-zephyr-blue-dark disabled:bg-zephyr-blue-dark rounded-lg px-6 py-2 disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-gray-500 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zephyr-blue-light transition-colors duration-150',
		className,
	)

	const childrenClassName = cn(
		loading ? 'opacity-0' : 'opacity-100',
	)

	return (
		<button
			className={classList}
			{...restProps}
		>
			<span className={childrenClassName}>
				{children}
			</span>
			{loading ? (
				<div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center text-white">
					<div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
				</div>
			) : null}
		</button>
	)
}

export default Button
